export const FINANCE_AUTH_KEY = 'finance_authenticated';

export function setFinanceAuthenticated(value: boolean) {
  if (value) {
    localStorage.setItem(FINANCE_AUTH_KEY, 'true');
  } else {
    localStorage.removeItem(FINANCE_AUTH_KEY);
  }
}

export function isFinanceAuthenticated(): boolean {
  return localStorage.getItem(FINANCE_AUTH_KEY) === 'true';
}